import request from '../request'

export default {
  peticionCompleta(idIncendio, data) {
    return request.post(`mediosEstatales/peticionCompleta/${idIncendio}`, data, { responseType: 'blob' })
  },
  guardarPdfSolicitud(data) {
    return request.post('mediosEstatales/guardarPdfSolicitud', data)
  },
  listarSolicitudes(idIncendio) {
    return request.get(`mediosEstatales/solicitudes/${idIncendio}`)
  },
  uploadSolicitud(data) {
    return request.post('mediosEstatales/uploadSolicitud', data)
  },
  eliminarSolicitud(idIncendio, filename) {
    return request.delete(`mediosEstatales/solicitudes/${idIncendio}`, { data: { filename } })
  },
  downloadSolicitud(idIncendio, filename) {
    return request.get(`mediosEstatales/download/${idIncendio}/${filename}`, {
      responseType: 'blob'
    })
  },
  createSolicitud(data) {
    return request.post('mediosEstatales/createSolicitud', data)
  },
  obtenerUltimaSolicitud(idIncendio) {
    return request.get(`/mediosEstatales/ultima/${idIncendio}`)
  }

}
